import React from 'react';
import './styles.scss';

const Button = ({ type = 'button', children, onClick, onMouseDown, buttonClass, primeBtn, ...rest }) => (
  <button
    {...rest}
    type={type}
    className={`button-custom ${buttonClass || ''} ${primeBtn ? 'prime-btn' : ''}`}
    onClick={onClick}
    onMouseDown={onMouseDown}
  >
    {children}
  </button>
);

export default React.memo(Button)